import type { StepConfigFor } from '../getStepConfig.types.ts';

export const AccountVerificationStepConfig = {
  title: ({ isHealthcareProvider }) =>
    isHealthcareProvider ? 'Account Verification Required' : 'Account Verification',
  statuses: {
    NOT_STARTED: {
      label: 'Not Started',
      cta: 'View',
      description: () => 'No action required.',
      context: () => 'No action required.',
    },
    PENDING: {
      label: 'Under Review',
      cta: 'Under Review',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'This account has been flagged as a potential duplicate. Please review the duplicate details and resolve.'
          : 'Your account is being reviewed by our team. No action is required. We will contact you if we need anything.',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'This account has been flagged as a potential duplicate and requires review.'
          : 'Your account is currently under review. No action is needed from you.',
    },
    COMPLETED: {
      label: 'Resolved',
      cta: 'View',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'Account verification has been resolved.'
          : 'Your account verification has been completed.',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'Account verification has been resolved.'
          : 'Your account verification has been completed.',
    },
    ERROR: {
      label: 'Action Required',
      cta: 'Review',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'There is an issue with the account verification that needs attention.'
          : 'There is an issue with your account. Our team will be in touch.',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'There is an issue with the account verification that needs attention.'
          : 'There is an issue with your account. Our team will be in touch.',
    },
  },
} satisfies StepConfigFor<'ACCOUNT_VERIFICATION'>;
